import React from 'react';
import { ArrowRight } from 'lucide-react';

function FollowUps({ suggestions, onPick }) {
  if (!suggestions || !suggestions.length) return null;
  return (
    <div className="chat-followups">
      {suggestions.map((s, idx) => (
        <button
          key={idx}
          type="button"
          className="chat-followup"
          onClick={() => onPick(s)}
        >
          <ArrowRight size={13} strokeWidth={2.75} />
          <span>{s}</span>
        </button>
      ))}
    </div>
  );
}

export default FollowUps;
